import { render, staticRenderFns } from "./xhlznApp.vue?vue&type=template&id=4d9d27cd"
import script from "./xhlznApp.vue?vue&type=script&lang=js"
export * from "./xhlznApp.vue?vue&type=script&lang=js"
import style0 from "./xhlznApp.vue?vue&type=style&index=0&id=4d9d27cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports